import React from 'react';

import {currentPermissions} from "../../constant";
import { useTranslation } from 'react-i18next';
import {getRoles} from "./rolesUtil";
import BusinessObjectPermissionItem from "./BusinessObjectPermissionItem";

const PermissionsListElem = ({ rolePermission }) => {
    const { i18n } = useTranslation();
    try {
        return (
            currentPermissions.map((permission, index) => {
                return (
                    <tr key={permission.key} className={index === currentPermissions.length - 1 ? "users__table-roles-row" : ""}>
                        <td className="users__table-item users__table-permission">
                            {i18n.t(`appRoles.scheme.permissions.${permission.key}`)}
                        </td>
                        {
                            getRoles().map((it) => {
                                return (
                                    <td key={it.id} className="users__table-item">
                                        <BusinessObjectPermissionItem role={it} rolePermission={rolePermission} permissionKey={permission.key}/>
                                    </td>
                                );
                            })
                        }
                    </tr>
                );
            })
        );
    } catch(err) {
        console.log(err);
        return null;
    }
};

export default PermissionsListElem;
